import { render, staticRenderFns } from "./apinvlisttax.vue?vue&type=template&id=15fdcd40"
import script from "./apinvlisttax.vue?vue&type=script&lang=js"
export * from "./apinvlisttax.vue?vue&type=script&lang=js"
import style0 from "./apinvlisttax.vue?vue&type=style&index=0&id=15fdcd40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports